<template>
  <FormItem :label="model.variable.label" :inline="inline">
    <Input type="text" v-model="newVal" @on-change="editVal" placeholder="YYYY-MM-DD">
      <div slot="prepend" @click="showPicker"><Icon type="ios-calendar-outline"></Icon></div>
    </Input>
    <div style="display: none;">
    <DatePicker
            :open="open"
            v-model="value"
            type="date"
            @on-change="changeDate">
        </DatePicker>
        </div>
  </FormItem>
</template>

<script>
import moment from 'moment'

export default {
  name: 'date-element',
  data: function () {
    return {
      open: false,
      newVal: this.model.val,
      value: null
    }
  },
  watch: {
    'val': function () {
      this.newVal = this.model.val
    }
  },
  props: ['model', 'inline'],
  methods: {
    changeDate: function (value) {
      this.newVal = moment(value).format('YYYY-MM-DD')
      // this.$emit('editVal', this.model, this.newVal)
      this.open = false
    },
    editVal: function () {
      this.model.val = this.newVal
      // this.$emit('editVal', this.model, this.newVal)
      this.open = false
    },
    showPicker: function () {
      if (this.value) {
        if (this.newVal && this.newVal.toString() === 'Invalid Date') {
          this.value = new Date()
        }
      }
      this.open = true
    }
  }
}
</script>
